import React, { ReactElement } from 'react'

import { Trans } from '@lingui/macro'

import { Text } from '../../../../styled'

export function MauLegalInfo(): ReactElement {
  return (
    <Text textAlign="left">
      <Trans>
        Tauro Markets is a brand registered in Mauritius by Inno Net Solutions. The website is owned by Inno Net
        Solutions (Company Registration: 208180, which is authorised, licensed and regulated by the Financial Services
        Commission bearing license No. GB24202909). Registered Office Address: Rue de la Democratie CO AllServ
        Management Ltd Office 306 3rd Floor Ebene Junction Ebene 72201MAURITIUS and Physical Address: Office Number 101,
        Palm Court Offices, 1st Floor, 90 St Jean Road, Quatre Brones, Mauritius
      </Trans>
    </Text>
  )
}
